import { useState } from 'react';

import { EnvironmentId } from '@/react/portainer/environments/types';

import { Badge, BadgeType } from '@@/Badge';
import { TooltipWithChildren } from '@@/Tip/TooltipWithChildren';

import { TrivySeverity } from '../../types';

import { FindingsSummary } from './FindingsSummary';

export function CountBadge({
  environmentId,
  namespace,
  workload,
  severity,
  type,
  label,
  count,
}: {
  environmentId: EnvironmentId;
  namespace: string;
  workload: string;
  severity: TrivySeverity;
  type: BadgeType;
  label: string;
  count: number;
}) {
  // The list is built from projected counts, so CVE detail is fetched for one
  // workload on demand rather than pulling every finding for every row upfront.
  const [hasHovered, setHasHovered] = useState(false);

  if (count === 0) {
    return null;
  }

  return (
    <TooltipWithChildren
      position="top"
      heading={`${label} (${count})`}
      message={
        <FindingsSummary
          environmentId={environmentId}
          namespace={namespace}
          workload={workload}
          severity={severity}
          label={label}
          total={count}
          enabled={hasHovered}
        />
      }
    >
      <span onMouseEnter={() => setHasHovered(true)}>
        <Badge type={type}>
          {label.charAt(0)} {count}
        </Badge>
      </span>
    </TooltipWithChildren>
  );
}
